export const MAX_MINS_BEFORE_APPOINTMENT = 4 * 60;

export const MAX_LAST_MINUTE_DISCOUNT = 50;

export const NEW_DISCOUNT_URL_FRAG = 'new-discount';
